///<reference path="../require.d.ts"/>
import {CheckedRoomRepository} from "../services/CheckedRoomRepository";
import {stringify} from "qs";

class InquiryButtonController {

    static $inject = ['$scope', 'CheckedRoomRepository'];

    ids: number[] = [];

    get disabled(): boolean {
        return !this.ids || this.ids.length === 0;
    }

    get length(): number {
        if (this.disabled) return 0;
        return this.ids.length;
    }

    get inquiryThis(): string {
        const m = /\/rooms\/(\d+)(\.html)?/.exec(location.pathname);
        return `/inquiry.html?id=${m[1]}`;
    }

    get inquiryChecked(): string {
        const qs = stringify({id: this.ids});
        return `/inquiry.html?${qs}`;
    }

    constructor(
        $scope: angular.IScope,
        checked: CheckedRoomRepository
    ) {
        this.ids = checked.load();
        const subscription = checked.observable.subscribe((ids) => {
            this.ids = ids;
        });
        $scope.$on('destroy', () => {
            subscription.dispose();
        });
    }

}

angular.module('hp').controller('InquiryButtonController', InquiryButtonController);




// WEBPACK FOOTER //
// ./controllers/InquiryButtonController.ts